import Title from "../Universal/Title.component";
import "../../styles/ComponentsStyles/Notification/NotificationCollapseContainer.style.css";

const NotificationCollapseContainer = ({ children, date }) => {
  return (
    <div className="flex-col align-start justify-start g-1">
      <div className="w-full flex-row align-center justify-start g-1">
        <Title className="text-no-wrap t-20">{date}</Title>
        <hr color="#DCDBDB" className="w-full" />
      </div>
      <div className="notificationHoldingParentContainer">{children}</div>
    </div>
  );
};

export default NotificationCollapseContainer;
